@import (reference) '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.wrapper {
  display: flex;
  flex-direction: column;
  padding: 100px 25px;
  text-align: center;
  gap: @space-16;
  align-items: center;
}

.header {
  color: @cancelled-indicator--header--text-color;
}
